module.exports = __webpack_public_path__ + "img/bankid-aml-logo-tiny.ba579f09.png";